import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


const initialState = {
    mapOrders: [],
    hardwoodBags: 0,
    cedarBags: 0,
    blackBags: 0,
    totalBags: 0,
    loading: true,
    reRender: false
};

const fetchMapOrdersStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchMapOrdersSuccess = ( state, action ) => {
    return updateObject( state, {
        mapOrders: action.mapOrders,
        loading: false,
        reRender: true
    } );
};

const fetchMapOrdersFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const addMapOrderToDelivery = ( state, action ) => {
    return updateObject( state,{        
        mapOrders: state.mapOrders.map(mapOrder => mapOrder.id === action.orderId?
            
            { ...mapOrder, 
                InDelivery: true                
            } : 
            mapOrder
        ),
        hardwoodBags: state.hardwoodBags + action.hardwoodBags,
        cedarBags: state.cedarBags + action.cedarBags,
        blackBags: state.blackBags + action.blackBags,
        totalBags: state.totalBags + action.totalBags,
        reRender: true
    });
}

const removeMapOrderFromDelivery = ( state, action ) => {
    return updateObject( state,{        
        mapOrders: state.mapOrders.map(mapOrder => mapOrder.id === action.orderId?
            
            { ...mapOrder, 
                InDelivery: false                
            } : 
            mapOrder
        ),
        hardwoodBags: state.hardwoodBags - action.hardwoodBags,
        cedarBags: state.cedarBags - action.cedarBags,
        blackBags: state.blackBags - action.blackBags,
        totalBags: state.totalBags - action.totalBags,
        reRender: true
    });
}



const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_MAPORDERS_START: return fetchMapOrdersStart( state, action );
        case actionTypes.FETCH_MAPORDERS_SUCCESS: return fetchMapOrdersSuccess( state, action );
        case actionTypes.FETCH_MAPORDERS_FAIL: return fetchMapOrdersFail( state, action );
        case actionTypes.ADD_MAP_ORDER_TO_DELIVERY: return addMapOrderToDelivery(state,action);
        case actionTypes.REMOVE_MAP_ORDER_FROM_DELIVERY: return removeMapOrderFromDelivery(state,action);
        default:
            return state;
    }
};



export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/mapOrders.js